import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAB8MS4BSmLB2Twc-HezmKf-PW8pZkyYZ8",
  authDomain: "driver-pulse.firebaseapp.com",
  projectId: "driver-pulse",
  storageBucket: "driver-pulse.firebasestorage.app",
  messagingSenderId: "602605219614",
  appId: "1:602605219614:web:4c350fa26242ef224c230f"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
